/**
 * mobile-nav.js
 *
 * Mobile navigation drawer: open/close behavior, body-scroll locking,
 * focus management, and ARIA state. Exposes `window.closeMobileNav` so a
 * shared ESC-key handler (see cart-drawer.js) can close the drawer too.
 *
 * Vanilla ES2017+, no dependencies. Safe to load with `defer`.
 */
(function initMobileNav() {
  'use strict';

  const toggle  = document.getElementById('mobileNavToggle');
  const closeEl = document.getElementById('mobileNavClose');
  const overlay = document.getElementById('mobileNavOverlay');
  const nav     = document.getElementById('mobileNav');

  // Without a toggle and a nav there is nothing to wire up.
  if (!toggle || !nav) return;

  /** Open the drawer, lock background scroll, and move focus inside. */
  function open() {
    nav.classList.add('open');
    if (overlay) overlay.classList.add('open');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';

    // Move focus to the first link so keyboard users land inside the drawer.
    const firstLink = nav.querySelector('a');
    if (firstLink) firstLink.focus();
  }

  /** Close the drawer, restore scroll, and return focus to the toggle. */
  function close() {
    nav.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    toggle.focus();
  }

  toggle.addEventListener('click', open);
  if (closeEl) closeEl.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);

  // Expose close globally so the shared ESC handler in cart-drawer.js
  // can dismiss the mobile nav without a direct dependency between files.
  window.closeMobileNav = close;
})();
